import React from 'react';
import { IMAGES } from '../mock';

export default function Achievements() {
  const stats = [
    { n: '120+', label: 'Ouros', sub: 'nacionais e regionais' },
    { n: '340+', label: 'Pratas', sub: 'nacionais e regionais' },
    { n: '580+', label: 'Bronzes', sub: 'nacionais e regionais' },
    { n: '900+', label: 'Menções', sub: 'honrosas' },
  ];
  return (
    <section className="gradient-bg-light py-20">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <p className="text-[#a020c9] tracking-widest text-sm font-semibold uppercase">— Nossos alunos —</p>
        <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-[#7a1fb0] mt-2 mb-4">Conquistas na OBMEP</h2>
        <div className="h-1 w-24 bg-[#ec2fd2] mx-auto mb-12 rounded"></div>

        <div className="flex flex-wrap justify-center gap-6 mb-12">
          {IMAGES.students.map((s, i) => (
            <div key={i} className="text-center">
              <div className="w-24 h-24 md:w-28 md:h-28 rounded-full overflow-hidden bg-gradient-to-br from-[#a020c9] to-[#ec2fd2] p-1">
                <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(s.name)}&backgroundColor=ffdfba,ffd5dc,c0aede,d1d4f9`} alt={s.name} className="w-full h-full rounded-full object-cover bg-white" />
              </div>
              <div className="mt-2 font-semibold text-[#2b1039]">{s.name}</div>
              <div className="text-xs text-[#5a3a6b]">Medalhista de ouro na OBMEP</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((s, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="text-4xl font-black text-[#a020c9]">{s.n}</div>
              <div className="font-bold text-[#2b1039] mt-1">{s.label}</div>
              <div className="text-xs text-[#5a3a6b] mt-1">{s.sub}</div>
            </div>
          ))}
        </div>

        <div className="mt-10 inline-block bg-gradient-to-r from-[#a020c9] to-[#ec2fd2] text-white rounded-2xl px-10 py-6 shadow-xl">
          <div className="text-4xl md:text-5xl font-black">1500+</div>
          <div className="uppercase tracking-widest text-sm mt-1">Premiações conquistadas na OBMEP</div>
        </div>
      </div>
    </section>
  );
}
